import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-apple-login-button",
  imports: [],
  templateUrl: "./apple-login-button.component.html",
  styleUrl: "./apple-login-button.component.scss",
})
export class AppleLoginButtonComponent {
  @Output() loginWithAppleClick = new EventEmitter<void>();

  loginWithApple() {
    this.loginWithAppleClick.emit();
  }
}
